import { cva } from 'class-variance-authority';

export const videoPlayerVariants = cva('relative overflow-hidden', {
  variants: {
    size: {
      small: '',
      medium: '',
      large: '',
      full: 'w-full',
    },
    rounded: {
      none: 'rounded-none',
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      full: 'rounded-full',
    },
    aspect: {
      auto: '',
      square: 'aspect-square',
      video: 'aspect-video',
      portrait: 'aspect-[3/4]',
    },
  },
  defaultVariants: {
    size: 'full',
    rounded: 'lg',
    aspect: 'video',
  },
});
